import KeycloakService from "@/services/keycloak-service";
import { useAuthStore } from "@/store/authStore";
import { createRouter, createWebHistory } from "vue-router";
import The404View from "../components/The404View.vue";
import TheUserView from "../components/TheUserView.vue";
import TheHome from "../components/TheHome.vue";
import TheOfficeManagement from "../components/TheOfficeManagement.vue";
import TheImportManager from "../components/TheImportManager.vue";
import TheMapEditor from "../components/TheMapEditor.vue";
import TheResultsView from "../components/TheResultsView.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      redirect: {
        name: "home",
      },
      meta: { requiresAuth: true },
    },
    {
      path: "/home",
      component: TheUserView,
      meta: { requiresAuth: true },
      children: [
        {
          path: "",
          name: "home",
          component: TheHome,
        },
        {
          path: "project-management",
          name: "project-management",
          component: TheOfficeManagement,
        },
        {
          path: "import",
          name: "import",
          component: TheImportManager,
        },
        {
          path: "map-editor",
          name: "map-editor",
          component: TheMapEditor,
        },
        {
          path: "results",
          name: "results",
          component: TheResultsView,
        },
      ],
    },
    {
      path: "/404",
      name: "404NotFound",
      component: The404View,
    },
    {
      path: "/:catchAll(.*)",
      redirect: "/404",
    },
  ],
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const authDeactivated = JSON.parse(import.meta.env.VITE_KEYCLOAK_DEACTIVATED);
  if (import.meta.env.DEV && authDeactivated) {
    next();
  } else {
    if (!authStore.authenticated) {
      KeycloakService.initKeycloakByKeycloakObj(undefined).then((val) => {
        if (val) {
          next();
        }
      });
    } else {
      next();
    }
  }
});

export default router;
